// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"47404277","382":"5cb4ad1f","438":"932614c7","545":"faf1c519","684":"f50c320e","706":"d7f3f30c","873":"5e96de66"}[chunkId] + ".chunk.js";
};